
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M215 43.6c-1.4.2-5.9.9-10 1.5-38.5 5.5-77.3 25.3-106 53.9-28.2 28.2-46 62.6-53.7 103.5-2 11.1-2.8 40.8-1.4 53.1 7 59.7 39.6 111.1 90.4 142.6 55 34.3 127 37.6 184.9 8.7 11.8-5.9 21.3-11.7 29.2-17.6l5.9-4.5 41.1 41c44.8 44.7 43.7 43.8 54.6 43 10.5-.8 18-8.3 18.8-18.8.8-10.9 1.6-9.8-43-54.6l-41-41.1 4.4-5.9c36.4-48.6 47-115 27.7-173.8C394 104.9 332.9 54.2 260 44.4c-9.3-1.2-38.4-1.7-45-.8m45 44c5.2.9 14.8 3.3 21.3 5.5 52.2 17.2 89.8 60.4 100.4 115.4 2.4 12.5 2.4 40.5-.1 53-12.2 61.8-58.4 108-120.1 120.1-12.9 2.5-39.6 2.5-53 0C155.2 371.7 112 335 94 284.5c-15.7-44.4-9.6-93.1 16.7-132.9 7.9-11.9 26-30.6 37.3-38.5 27.4-19.1 59.6-28.8 91.5-27.5 6.1.3 15.3 1.2 20.5 2"}})])
          )
        }
      }
    